<div *ngIf="showFilterBy" class="row mb-1 pb-1">
  <label class="col-md-3 col-form-label pt-0">
    {{getFilterLabel()}}
    <i *ngIf="getFilterTooltip()" class="bi bi-info-circle text-primary ms-1" [ngbTooltip]="getFilterTooltip()"
      placement="top"></i>
  </label>
  <div class="col-md-9">
    <app-dynamic-select-input [itemsList]="filterByList" [selectedItems]="filterObject.by" [bindId]="'key'"
      [multiple]="false" [maxSelected]="1" [defaultBindLabel]="'label'" [placeholder]="" [showCloseButton]="false"
      (newSelectEvent)="onSelectFilterBy($event)">
    </app-dynamic-select-input>
  </div>
</div>



<div *ngIf="filterObject.by && !menuProposit && getMultiple()" class="mb-3">
  <ng-select appendTo="body" dropdownPosition="bottom" [(items)]="availableItems"
    [id]="'select-input-' + filterObject.by" [clearable]="true" [bindLabel]="bindLabelString" [multiple]="getMultiple()"
    [closeOnSelect]="!getMultiple()" placeholder="Select item" [(ngModel)]="selectedItems"
    (search)="onSearchAction($event.term)" (change)="updatedataFilter($event)" (close)="onCloseMenu($event)">
    <ng-template ng-option-tmp let-item="item">
      <div class="d-flex align-items-center py-1">
        <!-- Column 1: Image -->
        <div class="flex-shrink-0 me-3" style="width: 40px; height: 40px;">
          <ng-container
            *ngIf="!item._imageError && (item.icon?.url || item.multimedia?.[0]?.url); else multiPlaceholder">
            <img [src]="item.icon?.url || item.multimedia[0].url" class="rounded-circle" alt="img" height="40"
              width="40" style="object-fit: cover;" (error)="onImageError(item)">
          </ng-container>
          <ng-template #multiPlaceholder>
            <div class="rounded-circle d-flex align-items-center justify-content-center bg-light"
              style="width: 40px; height: 40px;">
              <i class="bi bi-image-alt text-muted"></i>
            </div>
          </ng-template>
        </div>
        <!-- Column 2: Title + Stock/Price -->
        <div class="flex-grow-1 min-width-0">
          <div class="fw-medium text-truncate">{{item.title || item.default_label}}</div>
          <div class="d-flex flex-wrap gap-2 text-muted small">
            <span *ngIf="item.stock !== undefined" class="text-nowrap">
              <i class="bi bi-box-seam me-1"></i>{{ item.stock }}
            </span>
            <span *ngIf="item.price?.sale_price" class="text-nowrap">
              <i class="bi bi-tag me-1"></i>{{ item.price.sale_price.amount }} {{ item.price.sale_price.currency }}
            </span>
          </div>
        </div>
        <!-- Column 3: Status -->
        <div class="flex-shrink-0 ms-2">
          <span class="badge"
            [ngClass]="{'bg-light-success text-success':item.status == 'PUBLISHED', 'bg-light-warning text-warning':item.status == 'UNPUBLISHED'}">
            {{ item.status }}
          </span>
        </div>
      </div>
    </ng-template>
  </ng-select>
</div>

<div *ngIf="filterObject.by && !menuProposit && !getMultiple()" class="mb-3">
  <ng-select appendTo="body" dropdownPosition="bottom" [(items)]="availableItems"
    [id]="'select-input-' + filterObject.by" [clearable]="true" [bindLabel]="bindLabelString" [multiple]="getMultiple()"
    [closeOnSelect]="!getMultiple()" placeholder="Select item" [(ngModel)]="oneSelectedItem"
    (search)="onSearchAction($event.term)" (change)="updatedataFilter($event)" (close)="onCloseMenu($event)">
    <ng-template ng-option-tmp let-item="item">
      <div class="d-flex align-items-center py-1">
        <!-- Column 1: Image -->
        <div class="flex-shrink-0 me-3" style="width: 40px; height: 40px;">
          <ng-container
            *ngIf="!item._imageError && (item.icon?.url || item.multimedia?.[0]?.url); else singlePlaceholder">
            <img [src]="item.icon?.url || item.multimedia[0].url" class="rounded-circle" alt="img" height="40"
              width="40" style="object-fit: cover;" (error)="onImageError(item)">
          </ng-container>
          <ng-template #singlePlaceholder>
            <div class="rounded-circle d-flex align-items-center justify-content-center bg-light"
              style="width: 40px; height: 40px;">
              <i class="bi bi-image-alt text-muted"></i>
            </div>
          </ng-template>
        </div>
        <!-- Column 2: Title + Stock/Price -->
        <div class="flex-grow-1 min-width-0">
          <div class="fw-medium text-truncate">{{item.title || item.default_label}}</div>
          <div class="d-flex flex-wrap gap-2 text-muted small">
            <span *ngIf="item.stock !== undefined" class="text-nowrap">
              <i class="bi bi-box-seam me-1"></i>{{ item.stock }}
            </span>
            <span *ngIf="item.price?.sale_price" class="text-nowrap">
              <i class="bi bi-tag me-1"></i>{{ item.price.sale_price.amount }} {{ item.price.sale_price.currency }}
            </span>
          </div>
        </div>
        <!-- Column 3: Status -->
        <div class="flex-shrink-0 ms-2">
          <span class="badge"
            [ngClass]="{'bg-light-success text-success':item.status == 'PUBLISHED', 'bg-light-warning text-warning':item.status == 'UNPUBLISHED'}">
            {{ item.status }}
          </span>
        </div>
      </div>
    </ng-template>
  </ng-select>
</div>
<div *ngIf="filterObject.by && menuProposit" class="mb-3">
  <app-dynamic-filter-data-drag-drop [itemsList]="getAvailableItems()" [selectedItems]="getSelectedItems()"
    [filteredItems]="filterObject['data']" [multipleItems]="getMultiple()" [searchKey]="keySearch"
    [isPDP]="isSingleItemMode" (newSearchEvent)="onSearchAction($event)"
    (newSelectSearchEvent)="onSelectSearchAction($event)" (dataFilterModelChange)="updatedataFilter()"
    (listsChanged)="onListsChanged($event)">
  </app-dynamic-filter-data-drag-drop>
</div>

<!--button class="btn btn-block btn-primary" disabled="enableSave">Save</!--button-->